import React, { useEffect } from 'react';
import { autoScroll } from '../../../../utils/Autoscroll';
import ClaseENComponent from './claseENComponent';

const ClasesEN = () => {
    useEffect(() => {
        autoScroll(0,700)
        return () => {
            
        }
    }, [])

    return (
        <div className="container d-flex flex-column justify-content-center " id='materiel'>
            <h2 className='titleFont' >Course</h2>
            <hr />
            <ClaseENComponent />
        </div>
    );
};

export default ClasesEN;
